<!-- 菜单列表 -->
<template>
  <div class="menu-box">
    <div class="menu_mobile">
      <div v-for="(item, index) in $store.state.system.menuList" :key="index" class="link" @click="toPage(item)">
        <!-- <nuxt-link to="/control/navType?1">Eyeglasses</nuxt-link> -->
        <div class="menu-name">{{ item }}</div>
        <!-- <span>></span> -->
        <img class="link-icon" :src="more" alt="menuOpen" />
      </div>
      <LmobileNav />
    </div>
  </div>
</template>

<script>
import { typeName } from '@/assets/utils/renderData'
import LmobileNav from '@/components/Lnav/LmobileHelp/index.vue'
import more from '@/static/imgs/more.png'
export default {
  name: 'LmobileMenu',
  components: {
    LmobileNav
  },
  data() {
    return {
      more
    }
  },
  methods: {
    toPage(name) {
      if (name === 'Accessories') {
        this.$router.push({
          name: 'search-accessories',
          params: {
            type: 'accessories'
          }
        })
      }
      if (name === 'Eyeglasses' || name === 'Sunglasses') {
        this.$router.push({
          name: 'control-type',
          params: { type: name }
        })
      } else {
        this.$router.push({
          name: 'search-type',
          params: {
            type: typeName(name)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-box {
  padding: 16px 16px 0;
}
.menu_mobile {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.link {
  font-size: 0;
  display: flex;
  justify-content: space-between;
  height: 56px;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  padding: 0 20px;
  border-radius: 16px;
  border: 1px solid rgba(48, 103, 242, 0.06);
  box-shadow: 0 2px 16px rgba(48, 103, 242, 0.04), 0 1px 3px rgba(0, 0, 0, 0.02);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(48, 103, 242, 0.04) 0%, rgba(99, 128, 242, 0.02) 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(48, 103, 242, 0.1), 0 2px 6px rgba(0, 0, 0, 0.04);
    border-color: rgba(48, 103, 242, 0.16);
    &::before {
      opacity: 1;
    }
    .link-icon {
      transform: rotate(270deg) translateX(4px);
    }
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 4px rgba(48, 103, 242, 0.06);
    transition: all 0.1s ease;
  }

  .menu-name {
    position: relative;
    z-index: 1;
    text-decoration: none;
    font-size: 16px;
    font-weight: 500;
    color: #1a1d2e;
    letter-spacing: 0.2px;
  }
  .link-icon {
    position: relative;
    z-index: 1;
    width: 13px;
    transform: rotate(270deg);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0.45;
  }
}
</style>
